export enum ShareMenuAction {
  Email = 'Email',
  Download = 'Download',
  Copy = 'Copy',
}
